import varCommon from '@/utils/varCommon'
import { Notification } from 'element-ui';
import Encrypt from "encryptlong";

export default {
  methods: {
    // 取得时区的 YMDHIS
    getTimeZoneYMDHIS() {
      const currentDate = new Date();

      // 创建新的日期字符串
      const formattedDateTime = currentDate
        .toLocaleString("zh-CN", {
          timeZone: "Asia/Shanghai",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
        .replace(/[^\d]/g, "");

      return formattedDateTime;
    },
    formatAMPM(timestamp, type) {
      var dateObj = new Date(timestamp);
      var year = dateObj.getYear() + 1900;
      var month = dateObj.getMonth() + 1;
      var theDate = dateObj.getDate();
      var hours = dateObj.getHours();
      var ampm = hours >= 12 ? '下午' : '上午';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      var minute = dateObj.getMinutes();
      var second = dateObj.getSeconds();
      if (type && type === "day") {
        return year + "-" + (month < 10 ? '0' + month : month) + "-" + (theDate < 10 ? '0' + theDate : theDate);
      } else {
        return year + "-" + (month < 10 ? '0' + month : month) + "-" + (theDate < 10 ? '0' + theDate : theDate) + " " + ampm + " " + (hours < 10 ? '0' + hours : hours) + ":" + (minute < 10 ? '0' + minute : minute) + ":" + (second < 10 ? '0' + second : second);
      }
    },
    // 获取媒体临时预览路径
    getBlobURL(getAsFile) {
      if (window.createObjectURL != undefined) {
        return window.createObjectURL(getAsFile);
      } else if (window.URL != undefined) {
        return window.URL.createObjectURL(getAsFile);
      } else if (window.webkitURL != undefined) {
        return window.webkitURL.createObjectURL(getAsFile);
      }
      return null;
    },
    // 获取二维码媒体路径
    convertQrcodeMedia(filename) {
      return (
        `${process.env.BASE_API.replace("api2/", "") || location.origin + '/'}media/file/th/acc/${this.encrypt(JSON.stringify(
          {
            date: this.HandleDateYMDFormat(new Date()),
            filename,
            platform: 'DSY',
          }
        ))
          .replace(/\+/g, "-")
          .replace(/\//g, "_")
          .replace(/=+$/, "")}`
      );
    },
    // 仲裁还原 media 路径 By accId
    // 根据 DSY-1062 支付审核需求添加
    convertMediaByAccId(actionURL, accId, filename, path, userId) {
      let jsonObj = {
        date: this.HandleDateYMDFormat(new Date()),
        filename,
        accId,
        userId,
      };

      return (
        actionURL +
        "/th/arbitrate/acc/" + path + "/" +
        this.encrypt(JSON.stringify(jsonObj))
          .replace(/\+/g, "-")
          .replace(/\//g, "_")
          .replace(/=+$/, "")
      );
    },
    // 仲裁还原 media 路径 By orderId
    convertMedia(actionURL, orderId, src, path, type) {
      let jsonObj = {
        date: this.HandleDateYMDFormat(new Date()),
        orderType: type === 'pay' ? 0 : 1,
        filename: src,
        orderId: orderId,
      };

      return (
        actionURL +
        "/th/arbitrate/" + path + "/" +
        this.encrypt(JSON.stringify(jsonObj))
          .replace(/\+/g, "-")
          .replace(/\//g, "_")
          .replace(/=+$/, "")
      );
    },
    // rsa 加密
    encrypt(data) {
      let publicKey =
        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCX52PUepMjT3cWv/0so8YW4UJWWjUSMohHP7iF6r2WCf//Q14bQvnDOiYeAuwe9oaYi3w8KX1vYaDocWq8QC3F5fXMDEXMugplmU48c28n5TpqwrCP/7ohhDhQoRZov7g3EExMUkYxzSwAEeEku9CL4hUyUxu1ajuKhRAjCICK7QIDAQAB";
      const PUBLIC_KEY = publicKey;
      var encryptor = new Encrypt();
      encryptor.setPublicKey(
        "-----BEGIN PUBLIC KEY-----" + PUBLIC_KEY + "-----END PUBLIC KEY-----"
      );
      const result = encryptor.encryptLong(data);
      return result;
    },
    /* 时间日期选择器的快速选项设置
      [{ dateType: 1, midnight: true }, ...]
    */
    getPickerOptions(options) {
      let newArr = [],
        text = ''
      options.forEach(res => {
        const start = new Date();
        const end = new Date();
        start.setHours(0, 0, 0);
        end.setHours(0, 0, 0);
        switch (res.dateType) {
          case 'today':
            text = '今天';
            if (res.midnight) {
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 1);
            }
            break;
          case 'yesterday':
            text = '昨天';
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            if (!res.midnight) {
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
            }
            break;
          case 'oneWeek':
            text = '一周前';
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            break;
          case 'oneMonth':
            text = '30 天前';
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            break;
        }
        if (!res.midnight) {
          end.setHours(23, 59, 59, 999);
        }
        newArr.push({
          text,
          onClick(picker) {
            picker.$emit("pick", [start, end]);
          },
        });
      })
      return newArr;
    },
    // 将「秒数」转换为 天, 小时, 分, 秒
    HandleTimeStampToDatetimeFormat(time, type) {
      if (!time) return "-";
      let t = Number(time);
      let d = Math.floor(t / 86400);
      let h = Math.floor((t % 86400) / 3600);
      let m = Math.floor((t % 3600) / 60);
      let s = Math.floor((t % 3600) % 60);
      let dDisplay = d > 0 ? d + " 天 " : "";
      let hDisplay = h > 0 ? h + " 时 " : "";
      let mDisplay = m > 0 ? m + " 分 " : "";
      let sDisplay = s > 0 ? s + " 秒" : "";
      if (type === 'day') {
        return dDisplay + hDisplay + mDisplay + sDisplay;
      } else {
        return hDisplay + mDisplay + sDisplay;
      }
    },
    // 将秒数转换为 x 天 x 小时 x 分 x 秒格式
    formatDuration(seconds) {
      const days = Math.floor(seconds / (24 * 3600));
      seconds %= 24 * 3600;

      const hours = Math.floor(seconds / 3600);
      seconds %= 3600;

      const minutes = Math.floor(seconds / 60);
      seconds %= 60;

      const result = [];
      if (days) result.push(`${days} 天`);
      if (hours) result.push(`${hours} 时`);
      if (minutes) result.push(`${minutes} 分`);
      if (seconds) result.push(`${seconds} 秒`);

      return result.join(' ');
    },
    // 将「秒数」转换为 天, 小时, 分, 秒，冒号分隔
    HandleTimeStampToDatetimeFormatColon(time, type) {
      if (!time || time < 0) return "-";
      let t = Number(time);
      let d = Math.floor(t / 86400);
      let h = Math.floor((t % 86400) / 3600);
      let m = Math.floor((t % 3600) / 60);
      let s = Math.floor((t % 3600) % 60);
      let dDisplay = d < 10 ? ("0" + d + ":") : (d + ":");
      let hDisplay = h < 10 ? ("0" + h + ":") : (h + ":");
      let mDisplay = m < 10 ? ("0" + m + ":") : (m + ":");
      let sDisplay = s < 10 ? ("0" + s) : (s);
      if (type === 'day') {
        return dDisplay + hDisplay + mDisplay + sDisplay;
      } else {
        return hDisplay + mDisplay + sDisplay;
      }
    },
    // 根据用户回传中文类型
    translateUserType(userType) {
      switch (userType) {
        case 'super_admin':
          return '超级管理员';
        case 'top_agent':
          return '顶级代理';
        case 'admin':
          return '管理员';
        case 'seller':
          return '商户';
        case 'agent':
          return '代理';
        case 'agent_assistant':
          return '代理助理'
        case 'finance':
          return '财务';
        case 'customer':
          return '卡主';
        case 'kefu':
          return '客服';
        case 'credential_auditor':
          return '凭证审核员'
        case 'operator':
          return '操作员';
        case 'switchboard':
          return '查单值机';
        case 'operator_admin':
          return '操作员管理员';
        case 'sms_admin':
          return '短信模版管理员';
        case 'kefu_admin':
          return '客服管理员';
        default:
          return userType;
      }
    },
    translateTakeOrderModeType(type) {
      switch (type) {
        case 0:
          return '一般';
        case 1:
          return '手动';
        case 2:
          return '手动APP';
        default:
          return type;
      }
    },
    // 根据退款状态返回对应 html
    translateRefundStatusHTML(status) {
      switch (status) {
        case 0: // 未发起
          return `<span style="color: #00A600;">${varCommon.refundStatus[status]}</span>`;
        case 1: // 申请退款
          return `<span style="color: #f56c6c;">${varCommon.refundStatus[status]}</span>`;
        case 2: // 退款中
          return `<span style="color: #f56c6c;">${varCommon.refundStatus[status]}</span>`;
        case 3: // 退款完成
          return `<span style="color: #f56c6c;">${varCommon.refundStatus[status]}</span>`;
        case 4: // 退款失败
          return `<span style="color: #f56c6c;">${varCommon.refundStatus[status]}</span>`;
        case 5: // 拒绝退款
          return `<span style="color: #f56c6c;">${varCommon.refundStatus[status]}</span>`;
        case 99: // 申请直接退款
          return `<span style="color: #f56c6c;">${varCommon.refundStatus[status]}</span>`;
        case 100: // 直接退款成功
          return `<span style="color: #f56c6c;">${varCommon.refundStatus[status]}</span>`;
        default:
          return;
      }
    },
    // 显示小数点
    formatDecimalSeparator(number, decimals) {
      return Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals);
    },
    // 显示千分位分隔符和小数点
    formatNumberWithCommasAndDecimalSeparator(number, decimals = 0) {
      let num = this.formatDecimalSeparator(number, decimals)
      return this.NumberWithCommas(num)
    },
    // 显示层级
    formatUserNamePathTooltip(userNamePath) {
      if (userNamePath) {
        let userNamePathArray = userNamePath.split('/');
        let returnResult = '';
        userNamePathArray.forEach(function (item, index) {
          if (index !== 0) { // 最顶部不要显示
            if (index === userNamePathArray.length - 1) {
              returnResult += `<span style="color: #b8b8b8;"><i class="username-path-location-animation el-icon-location-information"></i> ${item} </span>`;
            } else {
              returnResult += `<span>[ ${item} ]</span>`;
            }
            if (index !== userNamePathArray.length - 1) { // 显示箭头
              returnResult += '&nbsp;&nbsp;<i class="el-icon-right"></i>&nbsp;&nbsp;';
            }
          }
        });
        return returnResult ? returnResult : '<span style="color: #b8b8b8;">无上级</span>';
      } else {
        return '<span style="color: #b8b8b8;">无上级</span>';
      }
    },
    // 显示层级不需要 html 版本
    formatPureUserNamePathTooltip(userNamePath) {
      if (userNamePath) {
        let userNamePathArray = userNamePath.split('/');
        let returnResult = '';
        userNamePathArray.forEach(function (item, index) {
          if (index !== 0) { // 最顶部不要显示
            returnResult += item;
            if (index !== userNamePathArray.length - 1) { // 显示箭头
              returnResult += '/';
            }
          }
        });
        return returnResult ? returnResult : '无上级';
      } else {
        return '无上级';
      }
    },
    HandleOrderStatusClass(code, type) {
      let status = varCommon.orderStatus.pay[code],
        style = ''
      if (type === 'withdraw') {
        status = varCommon.orderStatus.withdraw[code]
      } else if (type === 'financeWithdraw') {
        status = varCommon.orderStatus.financeWithdraw[code]
      }


      switch (code) {
        case 0:
        case 1:
          style = '000'
          break
        case 2:
        case 3:
          style = '00A600'
          break
        case 4:
        case 5:
        case 100:
          style = 'ff0000'
          break
        case 200:
        case 400:
          style = 'ff8500'
          break
        default:
          style = 'ff8500'
      }
      return `<div style="color: #${style};">${status}</div>`
    },
    HandleSelectOption(obj) {
      let newArr = []
      for (const [key, value] of Object.entries(obj)) {
        newArr.push({ label: value, value: key })
      }
      return newArr
    },
    HandleRemoveKey(arr, kn, kv) {
      let newArr = []
      arr.forEach(key => {
        if (key[kn] !== kv)
          newArr.push(key)
      })
      return newArr
    },
    HandleIsEmptyObjValid(obj) {
      return Object.keys(obj).length === 0 && obj.constructor === Object
    },
    HandlePageQueryValid() {
      if (this.HandleIsEmptyObjValid(this.$route.query)) {
        return false
      } else {
        return true
      }
    },
    HandleTableStatusInActiveClass({ row }) {
      if (Object.prototype.hasOwnProperty.call(row, "status") && !row.status) {
        return 'table-status-inactive'
      }
      if (Object.prototype.hasOwnProperty.call(row, "enable") && !row.enable) {
        return 'table-status-inactive'
      }
      if (Object.prototype.hasOwnProperty.call(row, "hidden") && row.hidden) {
        return 'table-status-inactive'
      }
      if (Object.prototype.hasOwnProperty.call(row, "isDeleted") && row.isDeleted) {
        return 'table-status-inactive'
      }
      return ''
    },
    HandleReadMore(s, len) {
      if (s && s.length > len + 1)
        return `${s.slice(0, len)}...`
      return s
    },
    HandleGetState(m, k) {
      return eval(`this.$store.state.${m}.${k}`)
    },
    HandleSetState(m, mt, o) {
      this.$store.commit(`${m}${mt}`, o)
    },
    HandleSlashValid(data) {
      return data.replace(/[/?]/g, '')
    },
    // 只能接受 0-9 数字
    HandleNumberOnly(data) {
      let reg = /^[0-9.]+$/
      if (!reg.test(data) && data)
        return false
      return true
    },
    HandleEnglishNumberOnly(data) {
      let reg = /^[A-Za-z0-9]+$/
      if (!reg.test(data) && data)
        return false
      return true
    },
    // 自动补零
    HandleZero(s, len) {
      return String(s).padStart(len, '0')
    },
    HandleDeepCopy(row) {
      return JSON.parse(JSON.stringify(row))
    },
    // 接受 new Date() 的日期并返回 YYYY-MM-DD hh:mm:ss
    HandleDateYMDFormat(date) {
      let yy = date.getFullYear(),
        mm = this.HandleZero(date.getMonth() + 1, 2),
        dd = this.HandleZero(date.getDate(), 2),
        h = this.HandleZero(date.getHours(), 2),
        m = this.HandleZero(date.getMinutes(), 2),
        s = this.HandleZero(date.getSeconds(), 2)
      return `${yy}-${mm}-${dd} ${h}:${m}:${s}`
    },
    // 移除物件内有空的资料
    ObjectClean(obj) {
      for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
          delete obj[propName];
        }
      }
      return obj
    },
    // 增加会计符号格式化
    NumberWithCommas(x) {
      var parts = x.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
    /* 复制文字
     text 作为要复制的文本
     NotificMsg 如果有传则作为提示语(不直接显示复制的内容)
    */
    CopyTextToClipboard(text, NotificMsg) {
      if (!navigator.clipboard) {
        this.FallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(function () {
        if (NotificMsg) {
          Notification.success(`${NotificMsg}`);
        } else {
          Notification.success(`已复制 ${text}`);
        }
      }, function (err) {
        Notification.error('复制失败: ', err);
      });
    },
    /* 无弹框提示 */
    CopyTextToClipboardNoNotification(text) {
      if (!navigator.clipboard) {
        this.FallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(function () {
      }, function (err) {
        Notification.error('复制失败: ', err);
      });
    },
    FallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? '成功' : '失败';
        Notification.success(`复制${msg}`);
      } catch (err) {
        Notification.error('复制失败: ', err);
      }
      document.body.removeChild(textArea);
    },
    // 浮点数相加 array
    arrayAccAdd(arr) {
      if (!Array.isArray(arr)) {
        throw new Error('Input must be an array.');
      }
      if (arr.length === 0) {
        return 0;
      }
      // Helper function to handle addition of two numbers
      function accAdd(arg1, arg2) {
        var r1, r2, m;
        try {
          r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
          r1 = 0;
        }
        try {
          r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
          r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        return (arg1 * m + arg2 * m) / m;
      }
      // Initialize the result with the first element of the array
      var result = arr[0];
      // Add the rest of the elements to the result
      for (var i = 1; i < arr.length; i++) {
        result = accAdd(result, arr[i]);
      }
      return result;
    },
    // 浮点数相加
    accAdd(arg1, arg2) {
      var r1, r2, m;
      try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
      try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    // 浮点数相减
    accSubtr(arg1, arg2) {
      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) { r1 = 0 }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) { r2 = 0 }
      m = Math.pow(10, Math.max(r1, r2));
      n = (r1 >= r2) ? r1 : r2;
      return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },
    // 浮点数相乘
    accMul(arg1, arg2) {
      if (arg1 !== undefined && arg2 !== undefined) {
        var m = 0;
        var s1 = arg1.toString();
        var s2 = arg2.toString();
        try {
          m += s1.split('.')[1].length;
        } catch (e) { () => { } }
        try {
          m += s2.split('.')[1].length;
        } catch (e) { () => { } }
        return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
      }
    },
    // 浮点数相除
    accDiv(arg1, arg2) {
      if (arg1 !== undefined && arg2 !== undefined) {
        var t1, t2, r1, r2;
        try {
          t1 = arg1.toString().split('.')[1].length;
        } catch (e) {
          t1 = 0;
        }
        try {
          t2 = arg2.toString().split('.')[1].length;
        } catch (e) {
          t2 = 0;
        }
        r1 = Number(arg1.toString().replace('.', ''));
        r2 = Number(arg2.toString().replace('.', ''));
        return this.accMul(r1 / r2, Math.pow(10, t2 - t1));
      }
    },
    /*
      生成索要凭证消息
      有 NotificMsg 显示 NotificMsg 否则显示默认 已复制凭证消息
      取代 CopyOrderDetailToClipboard
    */
    commonCopyOrderDetailToClipboard(orderType, orderDetail, NotificMsg) {
      let tradeType, tradeTime, tradeTimeDesc, transPayName, transPayeeName, tradeMemo;
      tradeType = tradeTime = tradeTimeDesc = transPayName = transPayeeName = tradeMemo = "";

      if (orderType === "pay") {
        tradeType = "支付订单";
        tradeMemo = "请帮忙确认下这单是否收款成功。";
        tradeTime = orderDetail.createdTime
          ? orderDetail.createdTime
          : "";
        tradeTimeDesc = "时间";
        transPayName = orderDetail.transPayName
          ? orderDetail.transPayName
          : "";
        transPayeeName = orderDetail.transPayeeName
          ? orderDetail.transPayeeName
          : orderDetail.bankCardName
            ? orderDetail.bankCardName
            : "";
      } else {
        tradeType = "兑换订单";
        tradeMemo = "请帮忙确认下这单是否兑换成功，如成功，提供下出款凭证。";
        tradeTime = orderDetail.withdrawedTime
          ? orderDetail.withdrawedTime
          : "";
        tradeTimeDesc = "交易时间";
        transPayName = orderDetail.transPayName
          ? orderDetail.transPayName
          : orderDetail.bankCardName
            ? orderDetail.bankCardName
            : "";
        transPayeeName = orderDetail.transPayeeName
          ? orderDetail.transPayeeName
          : orderDetail.toRealName
            ? orderDetail.toRealName
            : "";
      }
      // 显示层级，不显示最顶级
      let userLayer = orderDetail.usernamePath.split("/");
      userLayer.shift();

      // 解决部分复制信息不需要弹框
      let copyFunction;
      if (NotificMsg === false) {
        copyFunction = this.CopyTextToClipboardNoNotification;
      } else {
        copyFunction = this.CopyTextToClipboard;
      }
      if (orderDetail.qrcode) {
        copyFunction(
          `平台：${this.$store.state.app.switchProjectObj.title
          }${orderDetail.commonUserType === 1 ? '－通道型' : ''
          }\r\n类型：${tradeType}\r\n${this.getApplicant(orderDetail)}单号：${orderDetail.appOrder
          }\r\n平台订单：${orderDetail.orderId}\r\n扫码平台：${orderDetail.accType === 'wechatPay' ? '微信(wechatPay)' : '支付宝(aliPay)'
          }\r\n收款帐号：${orderDetail.collectionAccount}\r\n卡主：${orderDetail.username
          }\r\n层级：${userLayer ? userLayer.filter(item => item !== 'naruto' && item !== 'NARU').join("/") : ""
          }\r\n金额：${this.formatNumberWithCommasAndDecimalSeparator(
            orderDetail.originCost,
            2
          )}元\r\n${tradeTimeDesc}：${tradeTime}\r\n付款人：${orderDetail.tempPayerName ? orderDetail.tempPayerName : transPayName
          }\r\n收款人：${transPayeeName}\r\n${tradeMemo}`,
          NotificMsg || "已复制凭证信息"
        );
      } else {
        copyFunction(
          `平台：${this.$store.state.app.switchProjectObj.title
          }${orderDetail.commonUserType === 1 ? '－通道型' : ''
          }\r\n类型：${tradeType}\r\n${this.getApplicant(orderDetail)}单号：${orderDetail.appOrder
          }\r\n平台订单：${orderDetail.orderId}\r\n银行名称：${orderDetail.bankName
          }\r\n银行卡：${orderDetail.bankNo}\r\n卡主：${orderDetail.username
          }\r\n层级：${userLayer ? userLayer.filter(item => item !== 'naruto' && item !== 'NARU').join("/") : ""
          }\r\n金额：${this.formatNumberWithCommasAndDecimalSeparator(
            orderDetail.originCost,
            2
          )}元\r\n${tradeTimeDesc}：${tradeTime}\r\n付款人：${orderDetail.tempPayerName ? orderDetail.tempPayerName : transPayName
          }\r\n收款人：${transPayeeName}\r\n${tradeMemo}`,
          NotificMsg || "已复制凭证信息"
        );
      }
    },
    // 取得申请人（总代）
    getApplicant(orderDetail) {
      if (orderDetail.mchCode === "USER_WITHDRAW") {
        // 佣金提现
        return orderDetail.applyUsernamePath
          ? `申请人：${orderDetail.applyUsernamePath
            .split("/")[1]
            .substr(0, 4)}\r\n` // 取前4字串
          : "";
      } else if (orderDetail.mchCode === "USER_TOPUP") {
        // 财务提现
        return "申请人：GOGO\r\n";
      } else {
        return "";
      }
    },
    // 产生随机生成密码
    generateRandomPassword() {
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+";
      const length = 16;
      let randomString = "";
      let hasUpperCase = false;
      let hasLowerCase = false;
      let hasNumber = false;
      let hasSymbol = false;

      // 确保字串包含至少一个大写字母、一个小写字母、一个数字和一个符号
      while (!(hasUpperCase && hasLowerCase && hasNumber && hasSymbol)) {
        randomString = "";
        hasUpperCase = false;
        hasLowerCase = false;
        hasNumber = false;
        hasSymbol = false;

        // 随机产生指定数量的大写字母、小写字母、数字和特殊符号
        for (let i = 0; i < length; i++) {
          const randomIndex = Math.floor(Math.random() * chars.length);
          randomString += chars[randomIndex];

          if (/[A-Z]/.test(chars[randomIndex])) {
            hasUpperCase = true;
          } else if (/[a-z]/.test(chars[randomIndex])) {
            hasLowerCase = true;
          } else if (/[0-9]/.test(chars[randomIndex])) {
            hasNumber = true;
          } else {
            hasSymbol = true;
          }
        }
      }

      return randomString;
    },
    /*
    将原先类似于
    123352969124514793001_transfer_date_2024-02-01 15:19:25.395 的转移卡
    转换为
    123352969124514793001（卡号转移:2024-02-01）格式
    */
    transformBankCardField(input) {
      // 使用正则表达式匹配卡号、日期和时间
      const regex = /^(\d+)_transfer_date_(\d{4}-\d{2}-\d{2}) \d{2}:\d{2}:\d{2}\.\d+$/;
      const match = input.match(regex);
      if (match) {
        const cardNumber = match[1];
        const transferDate = match[2];
        return `${cardNumber}<span class="highlight-transfer-bankcard">（卡号转移：${transferDate}）</span>`;
      } else {
        // 返回原输入值或处理无效输入
        return input;
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/methodCommon.js